<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params, close }">
      <cod-details
        v-if="visible"
        :row="params.row"
        :close="close"
      ></cod-details>
    </template>
  </cTable>
</template>

<script>
import {
  getCodBill,
  add,
  getCountryCurrency,
  codReStatistics,
  getListDetails,
  update,
  batchWriteOff,
  codConfirmBill,
  delCod,
  addCnbNo,
  cancelClientOff,
  checkClientAlipay,
  getAnalyze,
  getBatchRate,
  saveBatchRate,
  cancelConfirm,
  waitOffBill,
  codDoHedge,
  changeBillHeader,
  batchExportBillFiles,
  setRate,
  getItemDetails,
  deleteItem
} from "@/api/branch/cod_list_new";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getCurrency } from "@/api/finance/currency";
import { getSearchConfig } from "@/api/finance/cod";
import { getBank } from "@/api/finance/bank";
import { getCodRate, getRateDetails } from "@/api/finance/cod_rate";
import cTable from "@/base/common/index";
import codDetails from "./details";
import numFun from "@/utils/numFun";
import { getContract } from "@/api/user/CustomerContract";
import { useModal } from "../../finances/b2b_bill_hq/rate.js";
export default {
  name: "branch_cod_list_new",
  components: {
    cTable,
    codDetails
  },
	mounted() {
		let rateModal = useModal.call(this,'codRefund');
		this.modals.rate.fields.unshift(...rateModal.fields)
		this.modals.rate.grid.unshift(...rateModal.grid)
		getCurrency().then(res=>{
			if(res.data.status){
				let currency = res.data.payload.rows.map(t=>{
					return {
						value:t.title,
						key:t.code
					}
				});
				this.$refs["table"].currency = currency
				console.log(currency);
				this.modals.writeOff.fields.forEach(t=>{
					if(t.key === 'check_amount_currency')t.options = currency
				})
			}
		})
	},
  data() {
    return {
      methods: {
        list: p => {
          return getCodBill(p);
        },
        getListDetails,
        // del,
        add,
        update,
        getSearchConfig,
        codConfirmBill,
        delCod,
        addCnbNo,
        getCurrency,
        batchWriteOff,
        getCountryCurrency,
        codReStatistics,
        getBank,
        getCodRate,
        getRateDetails,
        cancelClientOff,
        checkClientAlipay,
        getAnalyze,
        getBatchRate,
        saveBatchRate,
        cancelConfirm,
        waitOffBill,
        codDoHedge,
        getContract,
        changeBillHeader,
        batchExportBillFiles,
        setRate,
        getItemDetails,
        deleteItem,
        beforeModalList({ data }) {
          return data;
        }
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods("addCnbNo", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "Please Enter airway_number",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 10
              }
            }
          ]
        },
        update: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods("update", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ],
            }
          },
          grid: [
            // { total_fee: 24 },
            // { total_real_amount: 24 },
            { name: 24 },
            // { to_currency: 24 },
            // { to_currency_rate: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: this.$t("total_fee"),
              key: "total_fee",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("total_fee"),
							disabled:true,
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
								append:'USD'
              },
              default: 0
            },
            {
              name: this.$t("amount_receivable"),
              key: "total_real_amount",
              component: "Input",
							disabled:true,
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
								append:'USD'
              },
              default: 0
            },
						{
							name: this.$t("toCurrency"),
							key: "to_currency",
							component: "Select",
							placeholder: () => this.$t("select") + this.$t("toCurrency"),
							options: [],
							config:{
								label:'value',
								value:'key'
							},
							methods:{
								list({field,row}){
									field.options = this.$page.currency || []
								},
							}
						},
            {
              name: this.$t("to") + this.$t("rate"),
              key: "to_currency_rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("name")
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 2,
                type: "textarea"
              }
            }
          ]
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.$refs["form"].handleFilterData({
                ids: this.$page.selectAll.map((item) => item.id),
                bank_id: row.bank_id,
                types: "RECEIVE",
              });
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              transaction_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { bank: 24 },
            { check_amount: 24 },
            { check_amount_currency: 24 },
            { transaction_id: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$t("bank"),
              key: "bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label: ({ row }) => {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "account_type",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
                click({ obj, formData }) {
                  // console.log(obj);
                  // console.log(formData);
                  formData.bank_id = obj.id;
                },
              },
            },
            {
              name: this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
         rate: {
          type: "add",
          methods: {
            ok({ list, row, close }) {
              let data = {
                currency: row.currency,
                v: row.v
              };
              if (row.ids) data.ids = row.ids
              if (data.v == 1) {
                data.country = list
                data.scheme_id = row.selplan
              }
              if (this.type == "rate") data.id = row.id;
              else data.token = row.token;
              data['to_rate'] = {
                "aed_to_rate": row['aed_to_rate'],
                "sar_to_rate": row['sar_to_rate'],
                "kwd_to_rate": row['kwd_to_rate'],
                "bhd_to_rate": row['bhd_to_rate'],
                "omr_to_rate": row['omr_to_rate'],
                "qar_to_rate": row['qar_to_rate'],
                "iqd_to_rate": row['iqd_to_rate'],
                "ils_to_rate": row['ils_to_rate'],
                "jod_to_rate": row['jod_to_rate'],
                "cny_to_rate": row['cny_to_rate'],
                "usd_to_rate": row['usd_to_rate'],
                "usd_to_cny_rate": row['usd_to_cny_rate']
              }
              this.$page
                .handleRequestMethods(
                  this.type == "rate" ? "codReStatistics" : "saveBatchRate",
                  data
                )
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 1200,
              draggable: true,
              styles: { top: '20px' }
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px"
              }
            },
            formBind: {
              labelWidth: 120,
            },
            rules: {}
          },
          grid: [
            {
              selplan: 10,
              show() {
                return this.$modal.params.v == 1
              }
            }
          ],
          fields: [
            {
              key: "selplan",
              component: "Select",
              name() {
                return this.$modal.params.v == 1 ? '' : this.$t('plan_t')
              },
              placeholder: () => this.$t("select") + this.$t("planName"),
              options: [],
              config: {
                label: "name",
                value: "id"
              },
              formItemBind: {
                labelWidth: 0,
              },
              methods: {
                async list({ row, field }) {
                  let status = this.$modal.params.v == 1
                  if (!status) {
                    field.formItemBind.labelWidth = 120
                  }
                  field.options = (
                    await this.$page.handleRequestMethods("getCodRate", {
                      pageSize: 999
                    })
                  ).payload.rows;

                  if (row.selplan) {
                    let data = (
                      await this.$page.handleRequestMethods("getRateDetails", {
                        type: "select",
                        id: row.selplan,
                        currency: status ? '' : row.currency
                      })
                    ).payload;
                    if (status) {
                      let list = this.$page.getModal("rate").list;
                      list.forEach(ele => {
                        if (data.hasOwnProperty(ele.currency_id)) {
                          ele.rate = data[ele.currency_id];
                        }
                        ele.cny_to_usd = data.hasOwnProperty(4) ? data[4] : 0;
                      });
                    } else if (row.currency) {
                      Object.keys(data).forEach(t => {
                        row[t] = data[t]
                      })
                    }

                  }
                  this.$forceUpdate();
                },
                async "on-change"({ row, field, value }) {
                  if (!value) return;
                  let status = this.$modal.params.v == 1
                  let data = (
                    await this.$page.handleRequestMethods("getRateDetails", {
                      type: "select",
                      id: value,
                      currency: status ? '' : row.currency
                    })
                  ).payload;
                  if (status) {
                    let list = this.$page.getModal("rate").list;
                    list.forEach(ele => {
                      if (data.hasOwnProperty(ele.currency_id)) {
                        ele.rate = data[ele.currency_id];
                      }
                      ele.cny_to_usd = data.hasOwnProperty(4) ? data[4] : 0;
                    });
                  } else if (row.currency) {
                    Object.keys(data).forEach(t => {
                      row[t] = data[t]
                    })
                  }
                }
              }
            }
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500
            }
          },
          footer: { show: () => false }
        },
        analyze: {
          footer: {
            show: () => false
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("export"),
                type: "export",
                fnName: "export",
                bind: {
                  icon: "md-arrow-down",
                  type: "primary",
                  style: {
                    margin: "0 5px"
                  }
                }
              }
            ],
            methods: {
              export() {
                let data = JSON.parse(JSON.stringify(this.data));
                data.export = 1;
                this.$page
                  .handleRequestMethods("getAnalyze", data)
                  .then(res => {
                    this.$Message[res.status ? "success" : "error"]({
                      background: true,
                      content: res.msg,
                      duration: res.status ? 2 : 5
                    });
                    if (res.status) {
                      window.open(this.$globalUrl + res.payload);
                    }
                  });
              }
            }
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            title: this.$t("statistics"),
            listFn: "getAnalyze"
          },
          table: {
            config: {
              height: 600,
              showFooter: true,
              footerCellClassName: "col-red",
              footerMethod: ({ columns, data }) => {
                const sums = [];
                columns.forEach(column => {
                  let sumCell = null;
                  switch (column.property) {
                    case "seq":
                      sumCell = this.$t("total");
                      break;
                    case "name":
                      sumCell = "-";
                      break;
                    case "currency":
                      sumCell = "-";
                      break;
                    case "total_votes":
                      sumCell = sumCell = numFun.sumNumFun(
                        data,
                        column.property,
                        2
                      );
                      break;
                    default:
                      sumCell = numFun.sumNumFun(
                        data,
                        column.property,
                        2,
                        "format"
                      );
                  }
                  sums.push(sumCell);
                });
                // 返回一个二维数组的表尾合计
                return [sums];
              }
            },

            fields: [
              {
                name: () => this.$t("alipay_name"),
                key: "name",
                minWidth: 130
              },
              {
                name: () => this.$t("currencyCode"),
                minWidth: 80,
                key: "currency",
                align: "left"
              },
              {
                name: () => this.$t("Votes"),
                key: "total_votes",
                minWidth: 80,
                align: "left"
              },
              {
                name: () => this.$t("Total_original_currency"),
                key: "origin_amount",
                minWidth: 130,
                align: "left"
              },
              {
                name: () => this.$t("USD"),
                children: [
                  {
                    name: () => this.$t("total_amount"),
                    key: "amount_usd",
                    minWidth: 130,
                    align: "left"
                  },
                  {
                    name: () => this.$t("HandlingFee"),
                    key: "handling_fee_usd",
                    minWidth: 130,
                    align: "left"
                  },
                  {
                    name: () =>
                      this.$t("receivable") + "/" + this.$t("refundAmount"),
                    key: "confirm_fee_usd",
                    minWidth: 130,
                    align: "left"
                  }
                ]
              }
            ]
          }
        },
        hedge: {
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              data.hedge_bill_list = this.selectAll;
              let requestName = "";
              if (data.hedge_bill_amount > 0) {
                data.token = row.token;
                data.bill_id = row.bill_id;
                data.bill_amount = row.check_amount;
                requestName = "codDoHedge";
              } else {
                requestName = "batchWriteOff";
                data.ids = [row.id];
                data.bank_id = row.bank_id;
                data.types = "REFUND";
              }
              this.$page.handleRequestMethods(requestName, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            },
            checkTable({ row }) {
              this.$refs["form"].checkList = row;
							let formData = this.$refs["form"].formData
              let amount = 0;
              row.map(item => {
								if(item.currency === 'CNY'){
									amount += parseFloat(item.amount / formData.usd_to_cny_rate);
								}else{
									amount += parseFloat(item.amount);
								}
                return;
              });
              formData.hedge_bill_amount = parseFloat(
                amount.toFixed(2)
              );
							formData.final_amount = parseFloat(formData.bill_amount - formData.hedge_bill_amount)
              this.$forceUpdate();
            }
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true,
              styles: {
                top: "30px"
              }
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              // bank: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              transfer_method: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
            },
            formBind: {
              labelWidth: 140
            }
          },
          grid: [
						{client_name: 24,},
            { bill_amount: 24 },
            { bank: 12, transaction_id: 12 },
            { transfer_method: 24 },
            { remarks: 24 },
            {trans_obj:12, trans_to_currency: 12},
            { usd_to_cny_rate: 24 },
						{hedge_bill_amount:12,final_amount:12},
          ],
          fields: [
            {
              name: () => this.$t("clientName") + ":",
              key: "client_name"
            },
            {
              name: () =>
                this.$t("NotWrittenOff") + this.$t("reChAmount") + "(CNY):",
              key: "final_amount_cny"
            },
            {
              name: () => this.$t("HedgingAmount") + ":",
              key: "hedge_bill_amount",
              bind: {
                style: {
                  color: "red"
                }
              }
            },
						{
						  name: () => this.$t("FinalActualAmountRefund") + ":",
						  key: "final_amount"
						},
            {
              name: () => this.$t("setting") + this.$t('USD') + this.$t("rate"),
              key: "usd_to_cny_rate",
              placeholder: () => this.$t("enter") + this.$t("rate"),
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%",
                step: 0.0001
              },
              default: 0,
            },
            {
              name: this.$t("bank"),
              key: "bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label: ({ row }) => {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "account_type"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
                click({ obj, formData }) {
                  // console.log(obj);
                  // console.log(formData);
                  formData.bank_id = obj.id;
                }
              }
            },
						{
						  name: this.$t("ConvertedCurrencyObject"),
						  key: "trans_obj",
						  component: "Radio",
						  options: [
						    { label: this.$t("refundCod"), value: "COD" },
						    { label: this.$t("OtherAccountReceivable"), value: "OTH" }
						  ],
							default:'OTH',
						  bind: {
						    border: true
						  },
						  methods: {
						    async "on-change"({ row, value, formData }) {
						      this.$modal.getTable().clearCheckboxRow()
									formData.hedge_bill_amount = 0
									formData.final_amount = formData.bill_amount
						    }
						  }
						},
            {
              name: this.$t("ConvertedCurrency"),
              key: "trans_to_currency",
              component: "Radio",
              options: [
                { label: this.$t("to_rmb"), value: "CNY" },
                { label: this.$t("to_usd"), value: "USD" }
              ],
							default:'USD',
              bind: {
                border: true
              },
              methods: {
                async "on-change"({ row, value, formData }) {
                  
                }
              }
            },
            {
              name: this.$t("check_amount"),
              key: "bill_amount",
              component: "Input",
              bind: {
								append:'USD'
              },
							disabled:true,
              default: 0
            },

            {
              name: () => this.$t("methodTransfer"),
              key: "transfer_method",
              component: "Radio",
              bind: {
                border: true
              },
              options: [
                { label: this.$t("bank1"), value: "bank" },
                { label: this.$t("alipay"), value: "alipay" }
              ],
              default: "bank",
              methods: {
                "on-change"({ row }) {
                  if (row.transfer_method == "alipay") {
                    let data = {
                      ids: row.bill_id
                    };
                    checkClientAlipay(data).then(res => {
                      if (!res.data.status) this.$modal.disabledConfirm = true;
                    });
                  } else {
                    this.$modal.disabledConfirm = false;
                  }
                }
              }
            },
            {
              name: this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
              show({ row }) {
                return row.transfer_method != "alipay";
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 2
              }
            }
          ],
          table: {
            config: {
              height: 300,
							checkboxConfig:{
								checkMethod:({ row })=>{
									let modal = this.$refs['table'].getModal('hedge')
									let formData = modal.getFormData()
									return formData.trans_obj === 'COD'?row.currency === formData.trans_to_currency:['CNY','USD'].includes(row.currency)
								}
							}
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left"
              },
              {
                name: () => this.$t("bill_name"),
                align: "left",
                key: "name"
              },
              {
                name: () => this.$t("bill_number"),
                key: "bill_number",
                align: "left",
                minWidth: 150,
                render: (h, { row }) => {
                  if (row.bill_number) {
                    return h(
                      "a",
                      {
                        props: {
                          type: "warning",
                          size: "small"
                        },
                        on: {
                          click: () => {
                            if (row.b_type == "XB") {
                              this.$router.push({
                                name: "bill"
                              });
                            }
                            if (row.b_type == "HW") {
                              this.$router.push({
                                name: "hwBill"
                              });
                            }
                            this.$refs["table"].getModal("hedge").close();
                            this.$store.dispatch("pageUrl", row.bill_number);
                          }
                        }
                      },
                      row.bill_number
                    );
                  }
                }
              },
              {
                name: () => this.$t("codTypes"),
                key: "b_type"
              },
              {
                name: () => this.$t("currencyCode"),
                key: "currency"
              },
              {
                name: () => this.$t("amount"),
                key: "amount"
              }
            ]
          }
        },
        updateContract: {
          methods: {
            ok({ row, close }) {
              let data = {
                ids: this.$page.selectAll.map(item => item.id),
                header_id: row.header_id
              };
              this.$page
                .handleRequestMethods("changeBillHeader", data)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            formBind: {
              labelWidth: 100
            },
            rules: {
              header_id: [
                {
                  required: true,
                  message: "connot be empty",
                  type: "number",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            {
              header_id: 22
            }
          ],
          fields: [
            {
              name: this.$t("contractHeader"),
              key: "header_id",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contractHeader"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getContract")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: []
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },

          
          {
            key: "bill_status",
            placeholder() {
              return this.$t("select") + this.$t("bill_type");
            },
            component: "Select",
            options: []
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            }
          },
          {
            key: "all_pod",
            placeholder() {
              return (
                this.$t("whether") +
                this.$t("include") +
                " POD" +
                this.$t("exlType")
              );
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: 1
              },
              {
                label: this.$t("NO"),
                value: 2
              }
            ]
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              },
              type: "export",
              fnName: "export",
            },
            {
              name: () => this.$t("confirm") + this.$t("writeOff"),
              type: "pushClinet",
              fnName: "pushClinet",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              }
            },
            {
              name: () => this.$t("batch") + this.$t("rate"),
              type: "batchRate2",
              fnName: "batchRate",
              data: 2,
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("cancel") + this.$t("confirm"),
              type: "cancelConfirm",
              fnName: "cancelConfirm",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("batch") + this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              },
              // id: 371
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            pushClinet() {
              let data = { ids: this.selectAll.map(item => item.id) };
              this.$Modal.confirm({
                title:
                  this.$t("confirm") + this.$t("wait") + this.$t("writeOff"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("codConfirmBill", data).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            },
            cancelConfirm() {
              let data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("confirm"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelConfirm", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            writeOff() {
              let data = {
                check_amount_currency: "USD",
                check_amount: parseFloat(
                  this.selectAll
                    .map(item => parseFloat(item["total_real_amount"]))
                    .reduce((a, b) => a + b)
                    .toFixed(2)
                )
              };
              this.getModal("writeOff").open(data, function () {
                this.setTitle(this.$t("writeOff"));
                this.type = "batchWriteOff";
                this.disabledConfirm = false;
              });
            },
             batchRate({ field }) {
              let data = {
                billIds: this.selectAll.map(item => item.id),
                v: field.data
              };
              console.log(data);
              this.handleRequestMethods("getBatchRate", data, false, true).then(res => {
                let modal = this.getModal("rate")
                let data = []
                modal.modal.config.rules = {
                  currency: [
                    {
                      required: true,
                      message: "cannot be empty",
                      trigger: "change",
                    },
                  ],
                  usd_to_cny_rate: [{
                    required: true,
                    message: "cannot be empty",
                    trigger: "blur",
                    type: 'number',
                    min: 0.000001,
                    max: 9999999
                  }],
                }
                if (field.data == 1) {
                  data = res.payload.data.map(item => {
                    item.rate = item.currency.rate_to_usd;
                    item.cny_to_usd = item.currency.cny_to_usd;
                    item.currency = item.currency.code;
                    item.country = item.code;
                    modal.modal.config.rules[item.currency.toLocaleLowerCase() + '_to_rate'] = [
                      {
                        required: true,
                        message: "cannot be empty",
                        trigger: "blur",
                        type: 'number',
                        min: 0.000001,
                        max: 9999999
                      },
                    ]
                    return item;
                  });
                } else {
                  res.payload.required.map(t => {
                    modal.modal.config.rules[t.toLocaleLowerCase() + '_to_rate'] = [
                      {
                        required: true,
                        message: "cannot be empty",
                        trigger: "blur",
                        type: 'number',
                        min: 0.000001,
                        max: 9999999
                      },
                    ]
                  })
                }
                this.getModal("rate").open(
                  { token: res.payload.token, v: field.data, ...res.payload.to_rate, currency: res.payload.currency, ids: this.selectAll.map(item => item.id) },
                  function () {
                    this.setTitle(this.$t("batch") + this.$t("rate"));
                    this.type = "batchRate";
                    if (field.data == 1) this.list = data;
                  }
                );
                // this.$Message["success"]({
                //   background: true,
                //   content: res.msg
                // });
                // this.getList();
              });
            },
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("check_bill_number"),
          key: "check_bill_number",
          component: this.$hasPermission(323) || true ? "Button" : "span",
          minWidth: 190,
          fixed: "left",
					copy:true,
          bind: {
            type({ row }) {
              return row.all_pod ? "primary" : "error";
            },
            size: "small"
          },
          methods: {
            render({ row }) {
              return row.check_bill_number;
            },
            click({ row }) {
              if (this.$hasPermission(323) || true) {
                this.$page
                  .getModal("showDetails")
                  .setTitle(row.check_bill_number);
                this.$page.getModal("showDetails").open({ row });
              }
            }
          }
        },
        {
          name: () => this.$tz('类型'),
          key: 'types_txt',
          minWidth: 110,
        },
        {
          name: () => this.$t("ownership"),
          align: "left",
          key: "ownership_name",
          minWidth: 100
        },
        {
          name: () => this.$t("codNAme"),
          key: "name",
          minWidth: 150
        },
        {
          name: () => this.$t("total_votes"),
          key: "total_votes",
          width: 80
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          width: 80
        },
        {
          name:()=>this.$tz('收款,费用'),
          children: [
						{
						  name: () => this.$t("currency_t"),
						  key: "currency",
						  align: "left",
						  width: 110
						},
            {
              name: () => this.$t("total_amount"),
              key: "total_amount",
              align: "left",
              width: 110
            },
            {
              name: () => this.$t("total_fee"),
              align: "left",
              key: "total_fee",
              width: 120
            },
            {
              name: () => this.$t("TotalVATAmount"),
              align: "left",
              key: "total_vat",
              width: 120
            },
            /* {
              name: () => this.$t("deductExpenses"),
              key: "deductible_fee",
              align: "left",
              width: 120
            },
            {
              name: () =>
                this.$t("orther") +
                this.$t("bill_close_account_issuing_confirm"),
              key: "other_charges",
              align: "left",
              width: 120
            }, */
            // {
            //   name: () => this.$t("NotWrittenOff") + this.$t("reChAmount"),
            //   key: "final_amount",
            //   align: "left",
            //   width: 120
            // },
						{
						  name: () => this.$t('amount_actual') + this.$t("amount_receivable"),
						  align: "left",
						  key: "total_real_amount",
						  width: 120
						},
            // {
            //   name: () => this.$t("AmountHedged"),
            //   key: "hedge_amount",
            //   align: "left",
            //   width: 120
            // }
          ]
        },
        /* {
          name: this.$t("TransitionSettlementCurrency"),
          children: [
            {
              name: () => this.$t("toCurrency"),
              key: "to_currency",
              align: "left",
              width: 110
            },
            {
              name: () => this.$t("rate"),
              align: "left",
              key: "to_currency_rate",
              width: 120
            },
            {
              name: () => this.$t("ActualAmountRefund"),
              key: "to_total_real_amount",
              align: "left",
              width: 120
            }
          ]
        }, */

        {
          name: () => this.$t("finances") + this.$t("order_desc"),
          key: "remarks",
          align: "left",
          width: 100
        },
        {
          name: () => this.$t("operate"),
          align: "left",
          key: "operator_name",
          width: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170
        },
        {
          name: () => this.$t("check_time"),
          key: "check_time",
          width: 170
        },
        {
          name: () => this.$t("bank"),
          align: "left",
          key: "bank",
          width: 100
        },
        {
          name: () => this.$t("check_amount"),
          key: "check_amount",
          align: "left",
          minWidth: 120
        },
        {
          name: () => this.$t("transaction_id"),
          key: "transaction_id",
          align: "left",
          minWidth: 110
        },
        {
          name: () => this.$t("check_amount_currency"),
          key: "check_amount_currency",
          align: "left",
          minWidth: 100
        },
        /* {
          name: () => this.$t("cod_collection"),
          minWidth: 110,
          children: [
            {
              name: () => this.$t("bill_number"),
              key: "ys_check_bill_number",
              minWidth: 140,
              render: (h, { row }) => {
                if (row.ys_check_bill_number) {
                  return h(
                    "a",
                    {
                      props: {
                        type: "warning",
                        size: "small"
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: "branch_cod_refund_new"
                          });
                          this.$store.dispatch(
                            "pageUrl",
                            row.ys_check_bill_number
                          );
                        }
                      }
                    },
                    row.ys_check_bill_number
                  );
                }
              }
            },
            {
              name: () => this.$t("alipay_name"),
              key: "ys_check_bill_account",
              minWidth: 110
            },
            {
              name: () => this.$t("hang") + this.$t("Remarks"),
              key: "cod_agent_remark",
              minWidth: 100
            },
            {
              name: () => this.$t("finances") + this.$t("order_desc"),
              key: "cw_agent_remarks",
              width: 100
            },
            {
              name: () => this.$t("cod_ncnd_status"),
              key: "cod_ncnd_status_txt",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_agent_rate"),
              key: "cod_agent_rate",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing"),
              key: "bill_proceeds_issuing",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing_charge"),
              key: "bill_proceeds_issuing_charge",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing_confirm"),
              key: "bill_proceeds_issuing_confirm",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_ncnd_1_time"),
              key: "cod_ncnd_1_time",
              minWidth: 125
            },
            {
              name: () => this.$t("cod_ncnd_9_time"),
              key: "cod_ncnd_9_time",
              minWidth: 125
            },
          ]
        }, */
        {
              name: this.$t("operation"),
              type: "btns",
              width: 300,
              fixed: "right",
              list: [
                {
                  name: () => this.$t("addTo"),
                  type: "add",
                  fnName: "add",
                  bind: {
                    type: "error"
                  },
                  disabled({ row }) {
                    return row.status == 4 ? true : false;
                  },
                },
                {
                  name: () => this.$t("update"),
                  type: "update",
                  fnName: "update",
                  bind: {
                    type: "success"
                  },
                  disabled({ row }) {
                    return row.status == 4 ? true : false;
                  },
                },
                {
                  name: () => this.$t("rate"),
                  type: "rate",
                  fnName: "rate",
                  data: 2,
                  bind: {
                    type: "warning"
                  },
                  disabled({ row }) {
                    return row.status == 4 ? true : false;
                  },
                },
                {
                  name: () => this.$t("delete"),
                  type: "delete",
                  fnName: "delete",
                  disabled({ row }) {
                    return row.status == 4 ? true : false;
                  },
                }
              ],
              methods: {
                add({ row }) {
                  this.getModal("add").open({ id: row.id }, function () {
                    this.setTitle(
                      row.check_bill_number + "(" + this.$t("addTo") + ")"
                    );
                  });
                },
                update({ row }) {
                  this.handleRequestMethods("getItemDetails", row.id).then(res => {
                    this.getModal("update").open(res.payload, function () {
                      this.setTitle(
                        row.check_bill_number + "(" + this.$t("update") + ")"
                      );
                    });
                  });
                },
                rate({ row, field }) {
                  this.handleRequestMethods("getCountryCurrency", row.id).then(
                    res => {
                        let modal = this.getModal("rate")
                        let data = []
                        modal.modal.config.rules = {
                          currency: [
                            {
                              required: true,
                              message: "cannot be empty",
                              trigger: "change",
                            },
                          ],
                          usd_to_cny_rate: [{
                            required: true,
                            message: "cannot be empty",
                            trigger: "blur",
                            type: 'number',
                            min: 0.000001,
                            max: 9999999
                          }],
                        }
                        if (field.data == 1) {
                          data = field.data == 1 && res.payload.country.map(item => {
                            item.rate = item.currency.rate_to_usd;
                            item.cny_to_usd = item.currency.cny_to_usd;
                            item.currency = item.currency.code;
                            item.country = item.code;
                            modal.modal.config.rules[item.currency.toLocaleLowerCase() + '_to_rate'] = [
                              {
                                required: true,
                                message: "cannot be empty",
                                trigger: "blur",
                                type: 'number',
                                min: 0.000001,
                                max: 9999999
                              },
                            ]
                            return item;
                          });
                        } else {
                          res.payload.required.map(t => {
                            modal.modal.config.rules[t.toLocaleLowerCase() + '_to_rate'] = [
                              {
                                required: true,
                                message: "cannot be empty",
                                trigger: "blur",
                                type: 'number',
                                min: 0.000001,
                                max: 9999999
                              },
                            ]
                          })
                        }
                        console.log(modal.modal.config.rules);
                        this.getModal("rate").open(
                          { id: row.id, v: field.data, selplan: row.scheme_id, ...res.payload.to_rate, currency: res.payload.currency },
                          function () {
                            this.setTitle(
                              row.check_bill_number + "(" + this.$t("rate") + ")"
                            );
                            this.type = "rate";
                            if (field.data == 1) this.list = data;
                          }
                        );
                    }
                  );
                },
                delete({ row }) {
                  this.$Modal.confirm({
                    title: this.$t("whether") + this.$t("delete"),
                    width: 300,
                    content: this.$t("bill1") + "(" + row.check_bill_number + ")",
                    onOk: () => {
                      this.handleRequestMethods("deleteItem", row.id).then(res => {
                        this.$Message["success"]({
                          background: true,
                          content: res.msg
                        });
                        this.getList();
                      });
                    }
                  });
                }
              }
            }
      ]
    };
  },
  activated() {
    if (this.$store.state.user.pageUrl) {
      this.$refs["table"].$refs[
        "header"
      ].searchForm.keywords = this.$store.state.user.pageUrl;
      this.$store.state.user.pageUrl = "";
      this.$refs["table"].getList();
    }
  },
  async created() {
    let data = (await getSearchConfig()).data.payload;
    let agentList = (await getAllClient()).data.payload.rows;
    let ownershipList = (await getCompanies()).data.payload;
    this.header.searchs.forEach(item => {
      if (item.key === "time_type") {
        item.options = Object.keys(data.time_type).map(item => ({
          value: item,
          label: data.time_type[item]
        }));
        this.$refs["table"].$refs["header"].searchForm["time_type"] =
          item.options[0].value;
      }
      if (item.key === "bill_status")
        item.options = Object.keys(data.receive_bill).map(item => ({
          value: item,
          label: data.receive_bill[item]
        }));
      if (item.key === "client_agent_id") item.options = agentList;
      if (item.key === "ownership") item.options = ownershipList;
    });
  }
};
</script>
